/**
 * Narrow helpers for reading fields off the loose `unknown` error we get from
 * the public-share meta query. Axios isn't imported here to avoid coupling
 * this feature's rendering to any HTTP client — we only care about the two
 * shapes the backend emits: a numeric status and an optional
 * `detail.reason` string on 410 responses.
 */

type AxiosLikeError = {
  response?: {
    status?: number;
    data?: { detail?: { reason?: string } | string };
  };
};

export function getAxiosErrorStatus(err: unknown): number | undefined {
  return (err as AxiosLikeError | null)?.response?.status;
}

export function getDetailReason(err: unknown): string | undefined {
  const detail = (err as AxiosLikeError | null)?.response?.data?.detail;
  if (typeof detail === 'object' && detail !== null && 'reason' in detail) {
    return detail.reason;
  }
  return undefined;
}
